module.exports = __webpack_public_path__ + "static/media/16.ded5053b.JPG";